import {
  GET_GLOBAL_SETTINGS,
  GET_GLOBAL_SETTING,
  UPDATE_GLOBAL_SETTING,
} from "./actions";

export function GlobalSettingsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_GLOBAL_SETTINGS}_FULFILLED`: {
      return _.mapKeys(action.payload.data, "id");
    }
    case `${GET_GLOBAL_SETTING}_FULFILLED`:
    case `${UPDATE_GLOBAL_SETTING}_FULFILLED`: {
      let newState = _.clone(state);
      const newItem = action.payload.data;
      const id = _.get(newItem, "id");
      newState[id] = newItem;
      return newState;
    }
    default:
      return state;
  }
}
